// Public-safe card identity copied onto groupCodes for guest preview.
// Price, fees, notes, and seller PII stay on the private sale.

/**
 * @param {Object} card - Sale card snapshot
 * @returns {Object}
 */
export function sanitizePreviewCard(card) {
  const variation = card?.variation ?? {};

  return {
    cardNumber: card?.cardNumber ?? null,
    name: Array.isArray(card?.name) ? card.name : (card?.name ? [card.name] : []),
    team: Array.isArray(card?.team) ? card.team : [],
    cardAttributes: Array.isArray(card?.cardAttributes) ? card.cardAttributes : [],
    series: card?.series ?? null,
    cardPath: card?.cardPath ?? null,
    variation: {
      cardParallelName: variation.cardParallelName ?? card?.cardParallelName ?? null,
      cardColor: variation.cardColor ?? null,
      cardPrintNumber: variation.cardPrintNumber ?? null,
      cardSupply: variation.cardSupply ?? null
    }
  };
}

/**
 * @param {Object} card - Preview card
 * @returns {string}
 */
export function formatPreviewCardName(card) {
  const names = Array.isArray(card?.name) ? card.name.filter(Boolean) : [];
  return names.join(' / ') || 'Card';
}

/**
 * @param {Object} variation
 * @returns {string}
 */
export function formatPreviewVariation(variation) {
  if (!variation) return '';
  const parallel = variation.cardParallelName;
  const hasPrint = variation.cardPrintNumber != null && variation.cardSupply != null;
  const print = hasPrint ? `${variation.cardPrintNumber}/${variation.cardSupply}` : '';
  return [parallel, print].filter(Boolean).join(' · ');
}
